import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class RonMonitorClock {
  now(): Date {
    return new Date();
  }
}
